import React, { useState, useEffect } from "react";
import Header from "../../Components/Header";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import PartnerDashboardDetails from "./PartnerDashboardDetails";
import { partner_Api } from "../../Configuration/Partner_URL";
import { toast } from "react-toastify";
import { Constants } from "../../CommonMethhods/Constants";
import PartnerDetailsEquity from "./PartnerPortfolioTab/PartnerDetailsEquity";
import ReportNew from "../ClientDashboard/ReportsNew/ReportsNew";
import { AESEncryption, ApiResDecrypt, decryptData } from "../../CommonMethhods/CommonMethods";
import { DASHBOARD_CLIENT_OVERVIEW } from "../../Configuration/API_URL";
import PartnerDetailsKyc from "../../../src/Pages/PartnerAdminDashboard/PartnerDetailsKyc";
import { axiosSsoJsonReserv1 } from "../../CommonMethhods/axiosPartnerInterceptor";

function PartnerDashboardPage() {
  const PartnerClientCode = localStorage.getItem("ClientId2");
  const storeToken = localStorage.getItem("ssoToken");
  const [loader, setLoader] = useState(true);
  const [status, setStatus] = useState(true);
  const [basicDetails, setbasicDetails] = useState();


  if (storeToken == null) {
    window.location.replace("/");
  }

  const getProfileDetail = async () => {
    
    let clientCode = "";
    let clientPan = "";
    let PartnerTabStatue = "";
    let tabOnboarding="";
    if(localStorage.getItem("tabOnboarding")){
      tabOnboarding=localStorage.getItem("tabOnboarding")
    }
    if (localStorage.getItem("ClientId2")) {
      clientCode = localStorage.getItem("ClientId2");
    } 
    if(localStorage.getItem("partnerPan")) {
      clientPan = localStorage.getItem("partnerPan");
    }
    if (localStorage.getItem("PartnerTabStatue")) {
      PartnerTabStatue = localStorage.getItem("PartnerTabStatue");
    }
    let payloadValue = {
      clientCode: clientCode,
      pan: clientPan,
      status: PartnerTabStatue,
      type:tabOnboarding
    };
    console.log("payloadvalue",payloadValue)
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetail = await axiosSsoJsonReserv1.post(
        DASHBOARD_CLIENT_OVERVIEW.BasicDetails_URL,

        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetail?.data);
      const response = res?.data;

      if (typeof response == "object") {
        console.log("response basic detail",response)
        setbasicDetails(response);
        localStorage.setItem("panId", response.pan);

        if (response.status == "created") {
          setStatus(false);
        }
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  
  useEffect(() => {
    getProfileDetail();
  }, []);

  console.log(basicDetails, "basicDetails");


  return (
    <>
      <Header headerDetails={basicDetails} />
      <SingleSignOnSideBar />
      <main id="main-content" >
        <PartnerDashboardDetails partnerData={basicDetails} loader={loader} />

        <div className="content-tabs width-zero">
          {/* <!-- main-nav-tabs --> */}

          <ul className="nav nav-tabs main-nav-tabs" id="myTab" role="tablist">

            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${status ? "" : "active"}`}
                data-toggle="tab"
                id="nav-home-tab"
                data-target="#nav-portfolio"
                type="button"
                role="tab"
                aria-controls="nav-portfolio"
                aria-selected="true"
                disabled={status}
              >
                {Constants.Portfolio}
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                // className="nav-link"
                className={`nav-link ${status ? "active" : ""}`}
                id="nav-Kyc"
                data-toggle="tab"
                data-target="#nav-kycTab"
                type="button"
                role="tab"
                aria-controls="nav-Kyc"
                aria-selected="false"
              // disabled={status}
              >
                {Constants.KYC}
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                // className={`nav-link ${status ? "active" : ""}`}
                className="nav-link"
                id="nav-contact-tab"
                data-toggle="tab"
                data-target="#nav-contact"
                type="button"
                role="tab"
                aria-controls="nav-contact"
                aria-selected="false"
                disabled={status}
              >
                {Constants.Reports}
              </button>
            </li>
          </ul>

          {/* <!-- main content tabs --> */}
          <div className="tab-content child-tabs-content" id="nav-tabContent">

            <div
              className={`reports-tab tab-pane  fade equity-tab ${status ? "" : "show active"
                } `}
              id="nav-portfolio"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              <PartnerDetailsEquity />
            </div>

            <div
              className={`kyc-tab tab-pane  fade  ${status ? "show active" : ""
                }`}
              id="nav-kycTab"
              role="tabpanel"
              aria-labelledby="nav-Kyc"
            >
              <PartnerDetailsKyc kycBasicDetails={basicDetails} loader={loader} />
            </div>

            <div
              className={`reports-tab tab-pane  fade  `}
              // className={`reports-tab tab-pane  fade  ${status ? "show active" : ""}`}
              id="nav-contact"
              role="tabpanel"
              aria-labelledby="nav-contact"
            >
              <ReportNew />
            </div>
          </div>
        </div>



      </main>
    </>
  );
}

export default PartnerDashboardPage;
